import { UserPermission } from '../../permission/enum';
export const resourcesRoutes = [
    {
        path: '',
        name: 'Resources',
        exact: true,
        component: () => import('../views/Resources.vue'),
        meta: {
            breadcrumb: [{ parent: 'Resources', label: 'Resources' }],
            permissions: [UserPermission.READ_GROUPS, UserPermission.WRITE_GROUPS],
        },
    },
];
